/* eslint-disable import/no-anonymous-default-export */
import styled from "styled-components";
import { DropdownPropTypes } from "./DropDown.type";

const Menu = styled.ul.attrs({
  className: "flex list-none",
})``;

const MenuItems = styled.li.attrs({
  className: "relative text-sm menu-items",
})``;

const DropDownButton = styled.button.attrs({
  className:
    "",
})``;

const Links = styled.a.attrs({
  className:
    "",
})``;

const Arrow = styled.span.attrs({
  className:
    "",
})``;

const DropDown = styled.ul.attrs<DropdownPropTypes>((props) => ({
  className: `${props.Show && "!block"}
  ${props.Submenu && ""}
  ${props.Base &&
    ""
    }
    `,
})) <DropdownPropTypes>``;

export default {
  Menu,
  MenuItems,
  DropDownButton,
  Links,
  Arrow,
  DropDown,
};
